import React from "react";
import { CheckCircle2, Circle } from "lucide-react";

const WINDOWS = [[30, "Days 1–30", "#00FFFF"], [60, "Days 31–60", "#F59E0B"], [90, "Days 61–90", "#00FF7F"]];

export const ActionPlan = ({ plan }) => {
  if (!plan) return <p className="text-sm text-slate-500">Loading plan…</p>;
  return (
    <div className="space-y-3" data-testid="funding-plan">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-display text-base text-[#00FFFF] uppercase tracking-wider">30 / 60 / 90-day plan</h3>
        <span className="font-mono text-xs text-slate-400" data-testid="funding-plan-progress">{plan.done} / {plan.total} done · docs {plan.docs_done}/{plan.docs_total}</span>
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        {WINDOWS.map(([w, label, color]) => (
          <div key={w} className="qs-panel p-3 space-y-2 border-t-2" style={{ borderTopColor: color }} data-testid={`funding-plan-window-${w}`}>
            <div className="text-[10px] uppercase tracking-widest" style={{ color }}>{label}</div>
            {plan.items.filter((i) => i.window === w).map((i, idx) => (
              <div key={idx} className="flex gap-2 text-[12px]" data-testid={`funding-plan-item-${w}-${idx}`}>
                {i.done ? <CheckCircle2 className="h-4 w-4 shrink-0 text-[#00FF7F]" /> : <Circle className="h-4 w-4 shrink-0 text-slate-600" />}
                <span className={i.done ? "text-slate-500 line-through" : "text-slate-300"}>{i.task}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
      <p className="text-[10px] text-slate-500">Items tick themselves from the shortlist statuses, pilot stages and the document checklist — no manual ticking.</p>
    </div>
  );
};
